import type { ListAccessLogsResult } from '@terafile/shared'
import { apiFetch } from './api.js'
import { supabase } from './supabase.js'

/**
 * アクセスログ閲覧 API クライアント。
 */

export type ListAccessLogsParams = {
  action?: string
  fromDate?: string
  toDate?: string
  fileId?: string
  page?: number
  limit?: number
}

export async function listAccessLogs(
  projectId: string,
  params: ListAccessLogsParams = {},
): Promise<ListAccessLogsResult> {
  const usp = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined) usp.set(k, String(v))
  }
  const qs = usp.toString()
  return apiFetch<ListAccessLogsResult>(`/projects/${projectId}/access-logs${qs ? `?${qs}` : ''}`)
}

/**
 * CSV エクスポート（PRO のみ）。Blob で返す。
 */
export async function downloadAccessLogsCsv(
  projectId: string,
  params: ListAccessLogsParams = {},
): Promise<Blob> {
  const {
    data: { session },
  } = await supabase.auth.getSession()
  const token = session?.access_token
  const apiBase = import.meta.env.VITE_API_URL ?? '/api'
  const usp = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined) usp.set(k, String(v))
  }
  const url = `${apiBase}/projects/${projectId}/access-logs.csv${
    usp.toString() ? `?${usp.toString()}` : ''
  }`
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) {
    throw new Error(`CSV ダウンロードに失敗しました（${res.status}）`)
  }
  return res.blob()
}
